import { createHttpClient } from '@/core/api/client/createHttpClient'
import { bearerTokenHook } from '@/core/api/interceptors/authInterceptor'
import { errorResponseHook } from '@/core/api/interceptors/errorInterceptor'
import { localeHook } from '@/core/api/interceptors/localeInterceptor'
import { traceRequestHook, traceResponseHook } from '@/core/api/interceptors/traceInterceptor'
import { getAppEnv } from '@/core/config/env'

const { apiGatewayUrl, apiTimeoutMs } = getAppEnv()

export const httpClient = createHttpClient({
  baseUrl: apiGatewayUrl,
  timeout: apiTimeoutMs,
  credentials: 'same-origin',
  headers: {
    Accept: 'application/json',
  },
  hooks: {
    beforeRequest: [bearerTokenHook, traceRequestHook, localeHook],
    afterResponse: [traceResponseHook, errorResponseHook],
  },
})
